import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';

import { PatientActions } from 'src/redux/actions/constant';
import patientService from 'src/services/apiServices/patientService';

const {
  GET_SINGLE_PATIENT_SUCCESS,
  GET_SINGLE_PATIENT_REQUEST,
  GET_SINGLE_PATIENT_FAILURE,
  GET_SINGLE_PATIENT_LOADING,
} = PatientActions;

function* getSinglePatient(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_SINGLE_PATIENT_LOADING });
    const response = yield call(patientService.getSinglePatient, action.payload);

    if (response?.status === 200) {
      yield put({ type: GET_SINGLE_PATIENT_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_SINGLE_PATIENT_FAILURE, payload: error });
  } 
}

function* getSinglePatientSaga() {
  yield takeEvery(GET_SINGLE_PATIENT_REQUEST, getSinglePatient);
}

export default getSinglePatientSaga;
